/**
 * In development mode, logs the intended action.
 * Properly handles both sync and async operations.
 */
export const executeSafely = async <R>(
  actionDescription: string,
  actionFn: () => R | Promise<R>
): Promise<R | void> => {
  if (process.env.NODE_ENV === "development") {
    alert(`[DEV ONLY] ${actionDescription}`);
    return;
  } else {
    const result = actionFn();
    // If the result is a Promise, await it; otherwise return it directly
    return result instanceof Promise ? result : result;
  }
};
